import { FeatureFlagValue, GenericFeatureFlags } from 'domains/featureFlags'
import { getValueByPath } from 'utils/getValueByPath'

export const mergeFFArrays = (
  overrideData: GenericFeatureFlags,
  presetData: GenericFeatureFlags,
  path: string,
) => {
  const overrideFFs = getValueByPath(overrideData, path)
  const presetFFs = getValueByPath(presetData, path)

  if (!overrideFFs && !presetFFs) {
    return undefined
  }

  if ((overrideFFs && !Array.isArray(overrideFFs)) || (presetFFs && !Array.isArray(presetFFs))) {
    throw new Error('Incorrect Feature Flags schema')
  }

  return [
    ...new Set([
      ...((overrideFFs as FeatureFlagValue[]) ?? []),
      ...((presetFFs as FeatureFlagValue[]) ?? []),
    ]),
  ]
}
